import request from 'api/requestUtils'
import type { definitions, paths } from '@luxuryescapes/contract-cart'

type CartItemsResponse = paths['/api/carts/{version}/{cartId}/items']['get']['responses']['200']['content']['application/json']
type ServerBedbankItem = definitions['bedbankItem']
type ServerHotelItem = definitions['hotelItem']

export type CartPayment = NonNullable<CartItemsResponse['payments']>[number]
export type CartLoyaltyData = NonNullable<CartItemsResponse['luxLoyalty']>

export type CartItemResponse = {
  items: Array<App.Checkout.AnyItem>
  total: number | undefined
  type: 'pending' | 'completed' | 'purchased'
  payments?: Array<CartPayment>
  loyalty?: CartLoyaltyData
  checkoutSource?: App.CheckoutSource
}

function mapCartItemType(type: CartItemsResponse['type']): CartItemResponse['type'] {
  if (type === 'completed' || type === 'purchased') return type
  return 'pending'
}

function mapCartItems(items: CartItemsResponse['items']): Array<App.Checkout.AnyItem> {
  return items.map(item => {
    // TODO(Venkat): Remove `isAccomBundle` fallback when enough time has passed.
    if ((item.itemType === 'hotel' && 'reservationType' in item && item.reservationType === 'instant_booking') || item.itemType === 'bedbankHotel') {
      const accommodationItem = item as ServerHotelItem | ServerBedbankItem
      if (!accommodationItem.accommBundleIds && 'isAccomBundle' in accommodationItem && accommodationItem.isAccomBundle) {
        accommodationItem.accommBundleIds = [accommodationItem.isAccomBundle as string]
      }
    }
    return item as App.Checkout.AnyItem
  })
}

export function getCartItems(cartId: string): Promise<CartItemResponse> {
  return request.get<CartItemsResponse>(`/api/carts/v2/${cartId}/items`, { credentials: 'include' }).then((res): CartItemResponse => ({
    items: mapCartItems(res.items),
    total: res.total ?? undefined,
    payments: res.payments,
    loyalty: res.luxLoyalty,
    checkoutSource: res.checkoutSource ?? undefined,
    type: mapCartItemType(res.type),
  }))
}
